import { render, staticRenderFns } from "./walletConfig.vue?vue&type=template&id=cd014d28&"
import script from "./walletConfig.vue?vue&type=script&lang=js&"
export * from "./walletConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports